export default __webpack_public_path__ + "static/media/3.8006cc6d.png";